class BrixReadMoreButtton {
  static init(...parameters) {
    return new BrixReadMoreButtton(...parameters);
  }

  constructor(block) {
    this.readMoreButton = block;
    this.elementsBelow = this.getElementsBelow();

    this.addReadLessButton();

    this.elementsBelow.forEach((element) => {
      element.classList.add('-hidden');
    });

    this.readMoreButton.addEventListener('click', () => {
      this.readMoreButton.classList.add('-hidden');
      this.readMoreButton.setAttribute('aria-expanded', true);
      this.readLessButton.setAttribute('aria-expanded', true);
      this.readLessButton.classList.remove('-hidden');
      this.elementsBelow.forEach((element) => {
        element.classList.remove('-hidden');
      });
      this.readLessButton.focus();
    });

    this.readLessButton.addEventListener('click', () => {
      this.readMoreButton.classList.remove('-hidden');
      this.readLessButton.classList.add('-hidden');
      this.readMoreButton.setAttribute('aria-expanded', false);
      this.readLessButton.setAttribute('aria-expanded', false);
      this.elementsBelow.forEach((element) => {
        element.classList.add('-hidden');
      });
      this.readMoreButton.focus();
    });
  }

  addReadLessButton() {
    const ids = this.elementsBelow.map((element) => element.id).join(' ');
    this.readMoreButton.setAttribute('aria-controls', ids);
    const parent = this.readMoreButton.parentNode;
    const { readLessLabel } = this.readMoreButton.dataset;

    this.readLessButton = document.createElement('button');
    this.readLessButton.innerHTML = readLessLabel;
    this.readLessButton.classList.add('brix-read-less-button');
    this.readLessButton.classList.add('-hidden');

    this.readLessButton.setAttribute('aria-expanded', false);
    this.readLessButton.setAttribute('aria-controls', ids);

    parent.appendChild(this.readLessButton);
  }

  getElementsBelow() {
    const children = this.readMoreButton.parentNode.childNodes;
    const elemIndex = [...children].indexOf(this.readMoreButton);

    const elementsBelow = [];
    [...children].forEach((child, index) => {
      if (child.nodeType === 1 && index > elemIndex) {
        elementsBelow.push(child);
      }
    });

    return elementsBelow;
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-read-more-button', BrixReadMoreButtton.init);
}
